import { Casa, Estudo, Mes, Perfil, Pessoa, Sessao, Territorio, Visita, } from '@sheafyield/dominio';
import { carimboSeguinte } from './protocolo.js';
import { notificarMutacaoLocal } from './sinalDeMutacao.js';
export class ErroDeEscrita extends Error {
    name = 'ErroDeEscrita';
}
const SCHEMAS = {
    perfil: Perfil,
    pessoa: Pessoa,
    visita: Visita,
    estudo: Estudo,
    sessao: Sessao,
    mes: Mes,
    territorio: Territorio,
    casa: Casa,
};
const NUNCA_SE_APAGAM = new Set(['perfil', 'mes']);
// Uma escrita local é: validar, carimbar (nunca para trás), escrever a linha
// e a entrada da fila NA MESMA transação, e só então avisar o motor.
export async function gravar(banco, tabela, entrada, agora = new Date().toISOString()) {
    const tabelaLocal = banco.tabela(tabela);
    const linha = await banco.transaction('rw', tabelaLocal, banco.fila, async () => {
        const anterior = await tabelaLocal.get(entrada.id);
        const candidata = {
            ...entrada,
            updated_at: carimboSeguinte(agora, anterior?.updated_at),
            server_updated_at: anterior?.server_updated_at ?? null,
            deleted: entrada.deleted ?? false,
        };
        const validada = SCHEMAS[tabela].parse(candidata);
        await tabelaLocal.put(validada);
        await banco.fila.add({
            tabela,
            id: validada.id,
            payload: validada,
            em: validada.updated_at,
        });
        return validada;
    });
    notificarMutacaoLocal();
    return linha;
}
export async function apagar(banco, tabela, id, agora) {
    if (NUNCA_SE_APAGAM.has(tabela))
        throw new ErroDeEscrita(`A tabela ${tabela} nunca é apagada; edite a linha.`);
    // A leitura e a escrita **na mesma transação**, como em `gravar` — e não
    // um `get` solto seguido de um `gravar` que abre a sua. Entre os dois, um
    // pull podia aplicar uma versão mais nova da linha, e a lápide levaria de
    // volta os campos velhos. Hoje só o `deleted` importa numa lápide, então
    // isso não mordia; a assimetria é que morde no dia em que alguém
    // acrescentar um campo derivado. O `gravar` de dentro entra nesta
    // transação (o escopo é o mesmo) e o aviso de mutação já sai da zona por
    // conta própria (ver `sinalDeMutacao.ts`).
    return banco.transaction('rw', banco.tabela(tabela), banco.fila, async () => {
        const atual = await banco.tabela(tabela).get(id);
        if (!atual)
            throw new ErroDeEscrita(`Não há ${tabela} com id ${id} para apagar.`);
        const { updated_at, server_updated_at, ...resto } = atual;
        void updated_at;
        void server_updated_at;
        return gravar(banco, tabela, { ...resto, deleted: true }, agora);
    });
}
//# sourceMappingURL=escrita.js.map